import { fg } from '@atlaskit/platform-feature-flags/fg';

/**
 * [CCI-18935] Quick actions block streaming - eligibility check.
 *
 * Returns true when quick action edits snap into the document a block at a time
 * rather than character by character, matching the block-level streaming set out
 * in the Modernized Agent Collaboration Drop 2 plan.
 */
export const isQuickActionsBlockStreamingEnabled = (): boolean =>
	fg('platform_editor_ai_quick_actions_buffered_apply');
